/// <reference types="datatables.net" />

import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from "../../_models/globals";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from "../../_services/api.integration";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';


@Component({
  selector: 'app-invoice-settings',
  templateUrl: './invoice-settings.component.html',
  styleUrls: ['./invoice-settings.component.css']
})
export class InvoiceSettingsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  //  dtOptions: DataTables.Settings = {};
  // dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  invoice: any;
  invoices: any = [];
  config: any = [];
  itemCodeValue: string;
  removeInvoice: any;
  removeItemCode: any;
  itemCodes: any = [];
  invoiceType: string;
  invoiceItem: string;
  statusText1: string;
  statusText2: string;

  constructor(private alertService: AlertService, private g: Globals, private http: HttpClient, private api: ApiIntegration) {
    this.g.page = "Invoice Settings"
    this.invoicess();
    //this.itemCode();
  }

  invoicess() {
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "INVOICE_TYPE", "INVOICE_TYPE", "INVOICE_TYPE").subscribe((data: any) => {
      this.g.loaderDisplay = "";

      this.invoices = data.tripleSetConfigDTOS;
      this.rerender();
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);

    });
  }

  itemCode(parentChild) {
    this.api.getValues("1", "ITEM_CODE", parentChild, parentChild).subscribe((data: any) => {
      this.itemCodes = data.tripleSetConfigDTOS;
      this.rerender();
    }, err => {
      this.alertService.error('Error', err);
    });
  }


  removeItem(item) {
    if (this.itemCodes && this.itemCodes.length > 0) {
      let index = this.itemCodes.indexOf(item);
      this.itemCodes.splice(index, 1);
    }
  }

  rerender(): void {
    /*this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });*/
  }

  ngOnInit() {
  }
  selectInvoiceType() {
    this.statusText2 = "";

    if (this.invoiceType == '' || this.invoiceType === null || this.invoiceType === undefined || this.invoiceType === 'undefined') {
      this.statusText2 = 'Please enter invoice Type';
    }
  }

  createInvoiceType() {
    this.g.loaderDisplay = "display";
    this.statusText2 = "";

    if (this.invoiceType == '' || this.invoiceType === null || this.invoiceType === undefined || this.invoiceType === 'undefined') {
      this.statusText2 = 'Please enter invoice Type';
    }

    if (this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createInvoiceConfiguration', {
      "child": "INVOICE_TYPE",
      "config": this.invoiceType,
      "control": "INVOICE_TYPE",
      "parent": "INVOICE_TYPE",
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Invoice type', 'Created Successfully');
          this.invoiceType = "";
          this.invoicess();

        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  selectedDeleteProduct(invoice) {
    this.removeInvoice = invoice;
  }

  selectedDeleteItem(item) {
    this.removeInvoice = item;
  }

  deleteReturnProduct() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteTripleSetConfig', {
      "id": this.removeInvoice.id
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.invoicess();
          this.alertService.success('Invoice type', 'Deleted Successfully');
          this.removeItem(this.removeInvoice)
        } else {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          //this.alertServie.error('Error',err);
        }
      )
  }
  selectInvoiceItem() {
    this.statusText1 = "";
    if (this.invoiceItem == '' || this.invoiceItem === null || this.invoiceItem === undefined || this.invoiceItem === 'undefined') {
      this.statusText1 = 'Please enter invoice Item';
    }
  }

  createItemCode() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";

    if (this.invoiceItem == '' || this.invoiceItem === null || this.invoiceItem === undefined || this.invoiceItem === 'undefined') {
      this.statusText1 = 'Please enter sub type';
    }

    if (this.statusText1 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createInvoiceConfiguration', {
      "child": this.invoice.config,
      "config": this.invoiceItem,
      "control": "ITEM_CODE",
      "parent": this.invoice.config,
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Invoice configuration', 'Created Successfully');
          this.itemCode(this.invoice.config);
          this.invoiceItem = "";
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
